module.exports = {"card":{"title7":"Recibo online","src-price":"/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN-OUT-DOLAR.svg"},"block-3":{"text2":"Además, podrás gestionar toda la información de tus pacientes: su historial clínico, citas, pagos, indicarles tareas, programar seguimientos o recetar online bajo el sistema homologado de prescripción de la OMC."}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/mx/public/views/opensalud-profesionales.json
// module id = 596
// module chunks = 116